<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="screenPark"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        :disabled="screen.park_id == ''"
        class="screenInput"
        v-model="screen.system_admin_id"
        placeholder="请选择创建人"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item1.username"
          :value="item1.id"
          v-for="(item1, index1) in ScreenSystemList"
          :key="index1"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.type"
        placeholder="请选择收价方式"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="面议" value="1"></el-option>
        <el-option label="标价" value="2"></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.is_up"
        placeholder="请选择是否上架"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.title"
        placeholder="标题"
      ></el-input>
      <el-button type="primary" @click="(screen.page = 1), fetchData()" style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/add')"
        >添加</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" width="120">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.system_admin ? scope.row.system_admin.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标签" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.des }}</div>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "" : scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收价方式">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "面议" : "标价" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否上架">
        <template slot-scope="scope">
          <span>{{ scope.row.is_up == 1 ? "上架" : "下架" }}</span>
        </template>
      </el-table-column>
      <!--       
      <el-table-column label="开票状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '2'
                ? 'success'
                : scope.row.status == '1'
                ? 'propertyInfo'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 2
                ? "已开票"
                : scope.row.status == 1
                ? "开票中"
                : "开票失败"
            }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="edit(scope.row)"
            v-if="roles.includes('/equipment/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="see(scope.row)"
            v-if="roles.includes('/equipment/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row)"
            v-if="roles.includes('/equipment/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>

    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @opened="openDrawer"
    >
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="120px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="所属园区" prop="park_id">
          <!-- @change="infoFormPark" -->
          <el-select
            filterable
            v-model="infoForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see'"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="创建人" prop="system_admin_id">
          <el-select
            filterable
            v-model="infoForm.system_admin_id"
            placeholder="请选择创建人"
            :disabled="czType == 'see'"
          >
            <el-option
              :label="item1.username"
              :value="item1.id"
              v-for="(item1, index1) in SystemList"
              :key="index1"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="标题" prop="title">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="infoForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="image" label="封面图">
          <el-upload
            :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="czType == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>

        <el-form-item label="收价方式" prop="type">
          <el-radio-group v-model="infoForm.type" :disabled="czType == 'see'">
            <el-radio :label="1">面议</el-radio>
            <el-radio :label="2">标价</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格" prop="price" v-if="infoForm.type == 2">
          <el-input
            class="w4 numInput"
            type="number"
            min="0"
            :disabled="czType == 'see'"
            v-model="infoForm.price"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否上架" prop="is_up">
          <el-radio-group v-model="infoForm.is_up" :disabled="czType == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标签" prop="desList">
          <span slot="label"><span style="color: #f00">*</span> 标签</span>
          <el-button
            v-if="czType != 'see'"
            size="mini"
            type="primary"
            @click="addDes()"
            >添加标签</el-button
          >
          <div>
            <div class="tabBox" v-for="(item, index) in desList" :key="index">
              <el-input
                style="width: 200px"
                :disabled="czType == 'see'"
                v-model="item.val"
                placeholder="请输入标签"
              ></el-input>
              <i
                v-if="czType != 'see' && index != 0"
                class="el-icon-delete"
                style="margin-left: 20px"
                @click="delDes(index)"
              ></i>
            </div>
          </div>
          <span style="color: #f00" v-show="tabShow">请输入标签</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="banners">
          <el-upload
            :limit="6"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="bannerList"
            :on-remove="handleRemovePic"
            :on-success="handleBannerSuccess"
            :disabled="czType == 'see'"
            :class="bannerList.length > 5 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="服务详情" prop="details">
          <Editor
            :disabled="czType == 'see'"
            ref="myQuillEditor"
            style="width: 100%"
            v-model="infoForm.details"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('infoForm')"
          >
            保存
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('infoForm')"
          >
            修改
          </el-button>
          <el-button type="propertyInfo" @click="drawer = false">
            关闭
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { mapGetters } from "vuex";
import { openPark, delImage, adminUser } from "@/api/index";
import {
  propertyList,
  propertyInfo,
  propertyDel,
  propertyAdd,
  propertyEdit,
} from "@/api/property";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      ScreenSystemList: [],
      infoForm: {},
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "通过",
          id: 1,
        },
        {
          title: "已驳回",
          id: 2,
        },
        {
          title: "待审核",
          id: 0,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        system_admin_id: "",
        type: "",
        is_up: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      drawer: false,
      fileList: [],
      bannerList: [],
      czType: "",
      SystemList: [],
      drawerTitle: "",
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        park_id: [
          {
            required: true,
            message: "请选择所属园区",
          },
        ],
        image: [
          {
            required: true,
            message: "请选择封面图",
          },
        ],
        des: [
          {
            required: true,
            message: "请输入描述",
          },
        ],
        system_admin_id: [
          {
            required: true,
            message: "请选择创建人",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择收价方式",
          },
        ],
        is_up: [
          {
            required: true,
            message: "请选择是否上架",
          },
        ],
        details: [
          {
            required: true,
            message: "请输入服务详情",
          },
        ],
        banners: [
          {
            required: true,
            message: "请选择轮播图",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
          },
        ],
      },
      desList: [
        {
          val: "",
        },
      ],
      tabShow: false,
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 添加标签
    addDes() {
      this.desList.push({
        val: "",
      });
    },
    delDes(index) {
      this.desList.splice(index, 1);
    },

    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.bannerList.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.infoForm.banners = list;
    },
    handleBannerSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.infoForm.banners = list;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.bannerList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },

    // 轮播图删除
    handleBannerRemove(file, fileList) {
      if (file.response.data.url) {
        this.bannerList.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.infoForm.banners = list;
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.infoForm.image) {
          this.delImg(this.infoForm.image);
        }
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.infoForm.image = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    openDrawer() {
      this.$refs.infoForm.clearValidate();
    },
    // 编辑
    editForm(formName) {
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          // desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
        return;
      } else {
        that.tabShow = false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let desList = [];
          that.desList.forEach((item) => {
            desList.push(item.val);
          });
          let data = {
            id: that.infoForm.id,
            title: that.infoForm.title,
            des: desList.join(","),
            image: that.infoForm.image,
            park_id: that.infoForm.park_id,
            system_admin_id: that.infoForm.system_admin_id,
            type: that.infoForm.type,
            is_up: that.infoForm.is_up,
            details: that.infoForm.details,
            banner: that.infoForm.banners.toString(","),
            price: that.infoForm.price,
          };
          propertyEdit(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
      }
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            title: that.infoForm.title,
            des: desList.join(","),
            image: that.infoForm.image,
            park_id: that.infoForm.park_id,
            system_admin_id: that.infoForm.system_admin_id,
            type: that.infoForm.type,
            is_up: that.infoForm.is_up,
            details: that.infoForm.details,
            banner: that.infoForm.banners.toString(","),
            price: that.infoForm.price,
          };
          propertyAdd(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 添加
    addMenu() {
      this.drawerTitle = "添加物业服务";
      this.czType = "add";
      this.infoForm = {
        title: "",
        des: "",
        image: "",
        park_id: "",
        system_admin_id: "",
        type: 1,
        is_up: 1,
        details: "",
        banners: [],
        price: "",
      };
      this.fileList = [];
      this.bannerList = [];
      if (this.userInfo.park_id !== 0) {
        this.infoForm.park_id = this.userInfo.park_id;
      }
      this.drawer = true;
    },
    // 表单创建人列表
    infoFormPark(e) {
      this.infoForm.system_admin_id = "";
      this.getSystem("add", e);
    },
    // 搜索园区
    screenPark(e) {
      this.screen.system_admin_id = "";
      this.getSystem("screen", e);
    },
    // 获取后台用户
    getSystem(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
        status: 1,
        index: index,
      };

      adminUser(data).then((response) => {
        if (type == "screen") {
          this.ScreenSystemList = response.data.lists;
        } else {
          this.SystemList = response.data.lists;
          // if (type == "add") {
          //   this.$set(this.SystemList, index, response.data.lists);
          // }
        }
      });
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.infoForm.image = "";
    },
    // 查看
    handleInfo(id) {
      // this.drawer = true;
      var that = this;
      propertyInfo({ id: id }).then((res) => {
        // that.infoForm = res.data.info;
        that.infoForm = {
          id: res.data.info.id,
          title: res.data.info.title,
          des: res.data.info.des,
          image: res.data.info.image,
          park_id: res.data.info.park_id,
          system_admin_id: res.data.info.system_admin_id,
          type: res.data.info.type,
          is_up: res.data.info.is_up,
          details: res.data.info.details,
          banners: res.data.info.banner.split(","),
          price: res.data.info.price,
        };
        that.desList = [];
        if (res.data.info.des) {
          let deslist = res.data.info.des.split(",");
          deslist.forEach((item) => {
            that.desList.push({
              val: item,
            });
          });
        }
        that.fileList = [];
        if (res.data.info.image) {
          this.fileList.push({ url: this.imageOss + res.data.info.image });
        }
        var list = res.data.info.banner.split(",");
        this.bannerList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
        that.getSystem("add", res.data.info.park_id);
      });
      this.drawer = true;
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        system_admin_id: "",
        type: "",
        is_up: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 删除
    del(val) {
      var that = this;
      const data = {
        id: val.id,
      };
      this.$confirm("确认删除？")
        .then((_) => {
          propertyDel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 编辑
    edit(val) {
      this.czType = "edit";
      this.infoForm.park_id = val.park_id;
      this.drawerTitle = "编辑";
      setTimeout(() => {
        this.handleInfo(val.id);
      }, 500);
    },
    // 查看
    see(val) {
      this.czType = "see";
      this.infoForm.park_id = val.park_id;
      this.drawerTitle = "查看";
      setTimeout(() => {
        this.handleInfo(val.id);
      }, 500);
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.infoForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.infoForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      propertyList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 10px 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
